<template>
  <button
    @click.capture.stop="click"
    class="btn relative"
    :disabled="disabled || loading"
    type="button"
  >
    <BeatLoader v-if="loading" class="on-top-loading" size="1rem" />
    <span :style="{ visibility: loading ? 'hidden' : 'visible' }">
      <slot />
    </span>
  </button>
</template>

<script>
import BeatLoader from 'components/shared/BeatLoader.vue';

export default {
  name: 'LoadingButton',
  components: {
    BeatLoader,
  },
  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    loading: {
      default: false,
      type: Boolean,
    },
  },
  emits: ['click'],
  methods: {
    click(e) {
      e.preventDefault();
      if (this.disabled || this.loading) {
        return;
      }

      this.$emit('click', e);
    },
  },
};
</script>

<style scoped lang="scss">
.relative {
  position: relative;
}

.on-top-loading {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  margin: auto;
  display: flex;
  justify-content: center;
}
</style>
